// Generated by tasks/generate_rm_meta.ts from the BMM URLs in tasks/bmm_versions.json.
// Do not edit by hand. Re-run `deno task generate:rm-meta`.

export interface BmmInvariantRow {
  schema: string;
  release: string;
  className: string;
  name: string;
  expression: string;
}

export const BMM_INVARIANTS: BmmInvariantRow[] = [
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "ACCESS_GROUP_REF",
    "name": "Type_validity",
    "expression": "type.is_equal (“ACCESS_GROUP”)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "AUTHORED_RESOURCE",
    "name": "Description_valid",
    "expression": "translations /= Void implies (description.details.for_all (d &#124;\ntranslations.has_key (d.language.code_string)))"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "AUTHORED_RESOURCE",
    "name": "Languages_available_valid",
    "expression": "languages_available.has (original_language)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "AUTHORED_RESOURCE",
    "name": "Original_language_valid",
    "expression": "code_set (Code_set_id_languages).has_code (original_language.as_string)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "AUTHORED_RESOURCE",
    "name": "Translations_valid",
    "expression": "translations /= Void implies (not translations.is_empty and not translations.has (orginal_language.code_string))"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Boolean",
    "name": "Completeness",
    "expression": "self or else (not self)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Boolean",
    "name": "Involutive_negation",
    "expression": "is_equal (not (not self))"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Boolean",
    "name": "Non_contradiction",
    "expression": "not (self and (not self))"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "CODE_PHRASE",
    "name": "Code_string_valid",
    "expression": "not code_string.is_empty"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Interval",
    "name": "Limits_comparable",
    "expression": "(not upper_unbounded and not lower_unbounded) implies lower.strictly_comparable_to (upper)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Interval",
    "name": "Limits_consistent",
    "expression": "(not upper_unbounded and not lower_unbounded) implies lower <= upper"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Interval",
    "name": "Lower_included_valid",
    "expression": "lower_unbounded implies not lower_included"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Interval",
    "name": "Upper_included_valid",
    "expression": "upper_unbounded implies not upper_included"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date",
    "name": "Day_valid",
    "expression": "not day_unknown implies valid_day (year, month, day)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date",
    "name": "Month_valid",
    "expression": "not month_unknown implies valid_month (month)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date",
    "name": "Partial_validity",
    "expression": "month_unknown implies day_unknown"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date",
    "name": "Year_valid",
    "expression": "valid_year (year)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date_time",
    "name": "Day_valid",
    "expression": "valid_day(year, month, day)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date_time",
    "name": "Fractional_second_valid",
    "expression": "has_fractional_second implies (not second_unknown and valid_fractional_second (fractional_second))"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date_time",
    "name": "Hour_valid",
    "expression": "valid_hour (hour, minute, second)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date_time",
    "name": "Minute_valid",
    "expression": "not minute_unknown implies valid_minute(minute)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date_time",
    "name": "Month_valid",
    "expression": "valid_month (month)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date_time",
    "name": "Partial_validity_day",
    "expression": "not day_unknown"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date_time",
    "name": "Partial_validity_hour",
    "expression": "not hour_unknown"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date_time",
    "name": "Partial_validity_minute",
    "expression": "minute_unknown implies second_unknown"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date_time",
    "name": "Partial_validity_month",
    "expression": "not month_unknown"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date_time",
    "name": "Partial_validity_year",
    "expression": "not month_unknown"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date_time",
    "name": "Second_valid",
    "expression": "not second_unknown implies valid_second (second)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_date_time",
    "name": "Year_valid",
    "expression": "valid_year (year)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_duration",
    "name": "Days_valid",
    "expression": "days >= 0"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_duration",
    "name": "Fractional_second_valid",
    "expression": "fractional_second >= 0.0 and fractional_second < 1.0"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_duration",
    "name": "Hours_valid",
    "expression": "hours >= 0"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_duration",
    "name": "Minutes_valid",
    "expression": "minutes >= 0"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_duration",
    "name": "Months_valid",
    "expression": "months >= 0"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_duration",
    "name": "Seconds_valid",
    "expression": "seconds >= 0"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_duration",
    "name": "Weeks_valid",
    "expression": "weeks >= 0"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_duration",
    "name": "Years_valid",
    "expression": "years >= 0"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_time",
    "name": "Fractional_second_valid",
    "expression": "has_fractional_second implies (not second_unknown and valid_fractional_second (fractional_second))"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_time",
    "name": "Hour_valid",
    "expression": "valid_hour(hour, minute, second)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_time",
    "name": "Minute_valid",
    "expression": "not minute_unknown implies valid_minute (minute)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_time",
    "name": "Partial_validity",
    "expression": "minute_unknown implies second_unknown"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_time",
    "name": "Second_valid",
    "expression": "not second_unknown implies valid_second (second)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_timezone",
    "name": "Max_hour_valid",
    "expression": "sign = 1 implies hour > 0 and hour <= Max_timezone_hour"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_timezone",
    "name": "Min_hour_valid",
    "expression": "sign = -1 implies hour > 0 and hour <= Min_timezone_hour"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_timezone",
    "name": "Minute_valid",
    "expression": "not minute_unknown implies valid_minute (minute)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Iso8601_timezone",
    "name": "Sign_valid",
    "expression": "sign = 1 or sign = -1"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "List",
    "name": "First_validity",
    "expression": "not is_empty implies first /= Void"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "List",
    "name": "Last_validity",
    "expression": "not is_empty implies last /= Void"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "PARTY_REF",
    "name": "Type_validity",
    "expression": "type.is_equal(“PERSON”) or type.is_equal(“ORGANISATION”) or type.is_equal(“GROUP”) or type.is_equal(“AGENT”)or type.is_equal(“ROLE”) or type.is_equal(“PARTY”) or type.is_equal(“ACTOR”)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Point_interval",
    "name": "Inv_point",
    "expression": "lower = upper"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "Proper_interval",
    "name": "Inv_not_point",
    "expression": "lower /= upper"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "UID",
    "name": "Value_valid",
    "expression": "not value.empty"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "UID_BASED_ID",
    "name": "Has_extension_valid",
    "expression": "extension.is_empty xor has_extension"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "VERSION_TREE_ID",
    "name": "Branch_number_valid",
    "expression": "branch_number /= Void implies branch_number.is_integer and then branch_number.as_integer >= 1"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "VERSION_TREE_ID",
    "name": "Branch_validity",
    "expression": "(branch_number = Void and branch_version = Void ) xor (branch_number /= Void and branch_version /= Void )"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "VERSION_TREE_ID",
    "name": "Branch_version_valid",
    "expression": "branch_version /= Void implies branch_version.is_integer and then branch_version.as_integer >= 1"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "VERSION_TREE_ID",
    "name": "Is_branch_validity",
    "expression": "is_branch xor branch_number = Void"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "VERSION_TREE_ID",
    "name": "Is_first_validity",
    "expression": "not is_first xor trunk_version.is_equal(“1”)"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "VERSION_TREE_ID",
    "name": "Trunk_version_valid",
    "expression": "trunk_version /= Void and then trunk_version.is_integer and then trunk_version.as_integer >= 1"
  },
  {
    "schema": "base",
    "release": "1.3.0",
    "className": "VERSION_TREE_ID",
    "name": "Value_valid",
    "expression": "not value.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ACTIVITY",
    "name": "Action_archetype_id_valid",
    "expression": "not action_archetype_id.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ACTOR",
    "name": "Roles_valid",
    "expression": "roles /= Void implies not roles.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ADDRESS",
    "name": "Type_valid",
    "expression": "type = name"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ARCHETYPED",
    "name": "Rm_version_valid",
    "expression": "not rm_version.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ATTESTATION",
    "name": "Items_valid",
    "expression": "items /= Void implies not items.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ATTESTATION",
    "name": "Reason_valid",
    "expression": "(reason.generating_type.is_equal (“DV_CODED_TEXT”) implies terminology (Terminology_id_openehr).has_code_for_group_id (Group_id_attestation_reason, reason.defining_code))"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "AUDIT_DETAILS",
    "name": "Change_type_valid",
    "expression": "terminology (Terminology_id_openehr).has_code_for_group_id (Group_id_audit_change_type, change_type.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "AUDIT_DETAILS",
    "name": "System_id_valid",
    "expression": "not system_id.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "AUTHORED_RESOURCE",
    "name": "Current_revision_valid",
    "expression": "(current_revision /= Void and not is_controlled) implies current_revision.is_equal (“(uncontrolled)”)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "AUTHORED_RESOURCE",
    "name": "Description_valid",
    "expression": "translations /= Void implies (description.details.for_all (d |\ntranslations.has_key (d.language.code_string)))"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "AUTHORED_RESOURCE",
    "name": "Languages_available_valid",
    "expression": "languages_available.has (original_language)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "AUTHORED_RESOURCE",
    "name": "Original_language_valid",
    "expression": "code_set (Code_set_id_languages).has_code (original_language.as_string)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "AUTHORED_RESOURCE",
    "name": "Revision_history_valid",
    "expression": "is_controlled xor revision_history = Void"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "AUTHORED_RESOURCE",
    "name": "Translations_valid",
    "expression": "translations /= Void implies (not translations.is_empty and not translations.has (orginal_language.code_string))"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "CODE_PHRASE",
    "name": "Code_string_valid",
    "expression": "not code_string.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "COMPOSITION",
    "name": "Category_validity",
    "expression": "terminology (Terminology_id_openehr).has_code_for_group_id (Group_id_composition_category, category.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "COMPOSITION",
    "name": "Content_valid",
    "expression": "content /= Void implies not content.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "COMPOSITION",
    "name": "Is_archetype_root",
    "expression": "is_archetype_root"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "COMPOSITION",
    "name": "Language_valid",
    "expression": "code_set(Code_set_id_languages).has_code(language)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "COMPOSITION",
    "name": "Territory_valid",
    "expression": "code_set(Code_set_id_countries).has_code(territory)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "CONTACT",
    "name": "Purpose_valid",
    "expression": "purpose = name"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_AMOUNT",
    "name": "Accuracy_is_percent_validity",
    "expression": "accuracy = 0 implies not accuracy_is_percent"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_AMOUNT",
    "name": "Accuracy_validity",
    "expression": "accuracy_is_percent implies valid_percentage (accuracy)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_DATE",
    "name": "Value_valid",
    "expression": "valid_iso8601_date(value)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_DATE_TIME",
    "name": "Value_valid",
    "expression": "valid_iso8601_date_time (value)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_DURATION",
    "name": "Value_valid",
    "expression": "valid_iso8601_duration (value)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_EHR_URI",
    "name": "Scheme_valid",
    "expression": "scheme.is_equal (Ehr_scheme)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_ENCAPSULATED",
    "name": "Charset_valid",
    "expression": "charset /= Void implies code_set (Code_set_id_character_sets).has_code (charset)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_ENCAPSULATED",
    "name": "Language_valid",
    "expression": "language /= Void implies code_set (Code_set_id_languages).has_code (language)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_IDENTIFIER",
    "name": "Id_valid",
    "expression": "not id.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_INTERVAL",
    "name": "Limits_consistent",
    "expression": "(not upper_unbounded and not lower_unbounded) implies (lower.is_strictly_comparable_to(upper) and lower <= upper)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_MULTIMEDIA",
    "name": "Compression_algorithm_validity",
    "expression": "compression_algorithm /= Void implies code_set (Code_set_id_compression_algorithms).has_code (compression_algorithm)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_MULTIMEDIA",
    "name": "Integrity_check_algorithm_validity",
    "expression": "integrity_check_algorithm /= Void implies code_set (Code_set_id_integrity_check_algorithms).has_code (integrity_check_algorithm)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_MULTIMEDIA",
    "name": "Integrity_check_validity",
    "expression": "integrity_check /= Void implies integrity_check_algorithm /= Void"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_MULTIMEDIA",
    "name": "Media_type_valid",
    "expression": "media_type /= Void and then code_set (Code_set_id_media_types).has_code (media_type)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_MULTIMEDIA",
    "name": "Not_empty",
    "expression": "is_inline or is_external"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_MULTIMEDIA",
    "name": "Size_valid",
    "expression": "size >= 0"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_ORDERED",
    "name": "Is_simple_validity",
    "expression": "(normal_range = Void and other_reference_ranges = Void) implies is_simple"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_ORDERED",
    "name": "Normal_range_and_status_consistency",
    "expression": "(normal_range /= Void and normal_status /= Void) implies (normal_status.code_string.is_equal (“N”) xor not normal_range.has (self))"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_ORDERED",
    "name": "Normal_status_validity",
    "expression": "normal_status /= Void implies code_set (Code_set_id_normal_statuses).has_code (normal_status)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_ORDERED",
    "name": "Other_reference_ranges_validity",
    "expression": "other_reference_ranges /= Void implies not other_reference_ranges.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_PARAGRAPH",
    "name": "Items_valid",
    "expression": "not items.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_PARSABLE",
    "name": "Formalism_valid",
    "expression": "not formalism.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_PARSABLE",
    "name": "Size_valid",
    "expression": "size >= 0"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_PERIODIC_TIME_SPECIFICATION",
    "name": "Value_valid",
    "expression": "value.formalism.is_equal (“HL7:PIVL”) or value.formalism. is_equal (“HL7:EIVL”)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_PROPORTION",
    "name": "Fraction_validity",
    "expression": "(type = pk_fraction or type = pk_integer_fraction) implies is_integral"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_PROPORTION",
    "name": "Is_integral_validity",
    "expression": "is_integral implies (numerator.floor = numerator and denominator.floor = denominator)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_PROPORTION",
    "name": "Percent_validity",
    "expression": "type = pk_percent implies denominator = 100"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_PROPORTION",
    "name": "Precision_validity",
    "expression": "precision = 0 implies is_integral"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_PROPORTION",
    "name": "Type_validity",
    "expression": "valid_proportion_kind (type)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_PROPORTION",
    "name": "Unitary_validity",
    "expression": "type = pk_unitary implies denominator = 1"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_PROPORTION",
    "name": "Valid_denominator",
    "expression": "denominator /= 0.0"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_QUANTIFIED",
    "name": "Magnitude_status_valid",
    "expression": "magnitude_status /= Void implies valid_magnitude_status (magnitude_status)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_TEXT",
    "name": "Encoding_valid",
    "expression": "encoding /= Void implies code_set (Code_set_id_character_sets).has_code (encoding)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_TEXT",
    "name": "Formatting_valid",
    "expression": "formatting /= void implies not formatting.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_TEXT",
    "name": "Language_valid",
    "expression": "language /= Void implies code_set (Code_set_id_languages).has_code (language)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_TEXT",
    "name": "Mappings_valid",
    "expression": "mappings /= void implies not mappings.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_TEXT",
    "name": "Valid_value",
    "expression": "not value.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_TIME",
    "name": "Value_valid",
    "expression": "valid_iso8601_time (value)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "DV_URI",
    "name": "Value_valid",
    "expression": "not value.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EHR",
    "name": "Compositions_valid",
    "expression": "for_all c in compositions | c.type.is_equal (\"VERSIONED_COMPOSITION\")"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EHR",
    "name": "Contributions_valid",
    "expression": "for_all c in contributions | c.type.is_equal(\"CONTRIBUTION\")"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EHR",
    "name": "Directory_in_folders",
    "expression": "folders /= Void implies folders.item(1) = directory"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EHR",
    "name": "Directory_valid",
    "expression": "directory /= Void implies directory.type.is_equal (\"VERSIONED_FOLDER\")"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EHR",
    "name": "Ehr_access_valid",
    "expression": "ehr_access.type.is_equal (\"VERSIONED_EHR_ACCESS\")"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EHR",
    "name": "Ehr_status_valid",
    "expression": "ehr_status.type.is_equal(\"VERSIONED_EHR_STATUS\")"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EHR",
    "name": "Folders_valid",
    "expression": "folders /= Void implies for_all f in folders | f.type.is_equal(\"VERSIONED_FOLDER\")"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EHR_ACCESS",
    "name": "Is_archetype_root",
    "expression": "is_archetype_root"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EHR_ACCESS",
    "name": "Scheme_valid",
    "expression": "not scheme.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EHR_STATUS",
    "name": "Is_archetype_root",
    "expression": "is_archetype_root"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ELEMENT",
    "name": "Inv_is_null_valid",
    "expression": "is_null() = (value = Void)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ELEMENT",
    "name": "Inv_null_flavour_indicated",
    "expression": "is_null() xor null_flavour = Void"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ELEMENT",
    "name": "Inv_null_flavour_valid",
    "expression": "is_null implies terminology (Terminology_id_openehr).has_code_for_group_id (Group_id_null_flavour, null_flavour.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ELEMENT",
    "name": "Inv_null_reason_valid",
    "expression": "null_reason /= Void implies is_null()"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ENTRY",
    "name": "Encoding_valid",
    "expression": "code_set (Code_set_id_character_sets).has_code (encoding)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ENTRY",
    "name": "Is_archetype_root",
    "expression": "is_archetype_root"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ENTRY",
    "name": "Language_valid",
    "expression": "code_set (Code_set_id_languages).has_code (language)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ENTRY",
    "name": "Other_participations_valid",
    "expression": "other_participations /= Void implies not other_participations.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ENTRY",
    "name": "Subject_validity",
    "expression": "subject_is_self implies subject.generating_type = “PARTY_SELF”"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EVENT",
    "name": "Offset_validity1",
    "expression": "offset /= Void and then offset = time.diff (parent.origin)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EVENT_CONTEXT",
    "name": "location_valid",
    "expression": "location /= Void implies not location.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EVENT_CONTEXT",
    "name": "Participations_validity",
    "expression": "participations /= Void implies not participations.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EVENT_CONTEXT",
    "name": "Setting_valid",
    "expression": "Terminology (Terminology_id_openehr).has_code_for_group_id (Group_id_setting, setting.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EXTRACT",
    "name": "Sequence_nr_valid",
    "expression": "sequence_nr >= 1"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EXTRACT_CONTENT_ITEM",
    "name": "Item_validity",
    "expression": "is_masked xor item /= Void"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EXTRACT_PARTICIPATION",
    "name": "Function_valid",
    "expression": "function /= Void and then function.generating_type.is_equal (“DV_CODED_TEXT”) implies terminology (Terminology_id_openehr).has_code_for_group_id (Group_id_participation_function, function.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EXTRACT_PARTICIPATION",
    "name": "Mode_valid",
    "expression": "mode /= Void and terminology (Terminology_id_openehr).has_code_for_group_id (Group_id_participation_mode, mode.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EXTRACT_UPDATE_SPEC",
    "name": "Overall_validity",
    "expression": "repeat_period /= Void or trigger_events /= Void"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EXTRACT_UPDATE_SPEC",
    "name": "Send_changes_only_validity",
    "expression": "send_changes_only implies persist_in_server"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EXTRACT_UPDATE_SPEC",
    "name": "Trigger_events_validity",
    "expression": "trigger_events /= Void implies not trigger_events.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "EXTRACT_VERSION_SPEC",
    "name": "Includes_revision_history_valid",
    "expression": "not include_data implies include_revision_history"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "FEEDER_AUDIT_DETAILS",
    "name": "System_id_valid",
    "expression": "not system_id.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "HISTORY",
    "name": "Events_valid",
    "expression": "(events /= Void and then not events.is_empty) or summary /= Void"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "HISTORY",
    "name": "Period_consistency",
    "expression": "is_periodic implies events.for_all (e: EVENT | e.offset. to_seconds.mod(period.to_seconds) = 0)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "HISTORY",
    "name": "Periodic_validity",
    "expression": "is_periodic xor period = Void"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "INSTRUCTION",
    "name": "Activities_valid",
    "expression": "activities /= Void implies not activities.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "INSTRUCTION_DETAILS",
    "name": "Activity_path_valid",
    "expression": "not activity_id.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "INTERVAL_EVENT",
    "name": "Interval_start_time_valid",
    "expression": "interval_start_time = time - width"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "INTERVAL_EVENT",
    "name": "Math_function_validity",
    "expression": "terminology (Terminology_id_openehr).has_code_for_group_id (Group_id_event_math_function, math_function.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ISM_TRANSITION",
    "name": "Current_state_valid",
    "expression": "terminology (Terminology_id_openehr).has_code_for_group_id (Group_id_instruction_states, current_state.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ISM_TRANSITION",
    "name": "Transition_valid",
    "expression": "transition /= Void implies terminology (Terminology_id_openehr).\nhas_code_for_group_id (Group_id_instruction_transitions, transition.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ITEM_LIST",
    "name": "Valid_structure",
    "expression": " items.forall (i:ITEM | i.type = \"ELEMENT\")"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ITEM_TABLE",
    "name": "Valid_structure",
    "expression": "rows.for_all (items.for_all (instance_of (\"ELEMENT\")))"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ITEM_TAG",
    "name": "Inv_key_valid",
    "expression": "not key.is_empty and key.is_justified"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ITEM_TAG",
    "name": "Inv_value_valid",
    "expression": "value /= Void implies not value.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "LOCATABLE",
    "name": "Archetype_node_id_valid",
    "expression": "not archetype_node_id.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "LOCATABLE",
    "name": "Archetyped_valid",
    "expression": "is_archetype_root xor archetype_details = Void"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "LOCATABLE",
    "name": "Links_valid",
    "expression": "links /= Void implies not links.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ORIGINAL_VERSION",
    "name": "Attestations_valid",
    "expression": "attestations /= Void implies not attestations.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ORIGINAL_VERSION",
    "name": "Is_merged_validity",
    "expression": "other_input_version_ids = Void xor is_merged"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ORIGINAL_VERSION",
    "name": "Other_input_version_uids_valid",
    "expression": "other_input_version_uids /= Void implies not other_input_version_uids.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTICIPATION",
    "name": "Function_valid",
    "expression": "function.generating_type.is_equal (\"DV_CODED_TEXT\") implies\nterminology (Terminology_id_openehr).has_code_for_group_id (Group_id_participation_function, function.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTICIPATION",
    "name": "Mode_valid",
    "expression": "mode /= Void implies terminology (Terminology_id_openehr).has_code_for_group_id (Group_id_participation_mode, mode.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY",
    "name": "Contacts_valid",
    "expression": "contacts /= Void implies not contacts.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY",
    "name": "Identities_valid",
    "expression": "not identities.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY",
    "name": "Is_archetype_root",
    "expression": "is_archetype_root"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY",
    "name": "Relationships_validity",
    "expression": "relationships /= Void implies (not relationships.is_empty and then relationships.for_all (r | r.source = self)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY",
    "name": "Reverse_relationships_validity",
    "expression": "reverse_relationships /= Void implies (not reverse_relationships.empty and then reverse_relationships.for_all (item | repository (\"demographics\").all_party_relationships.has_object (item) and then repository(\"demographics\").all_party_relationships.object (item).target = self))"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY",
    "name": "Type_valid",
    "expression": "type = name"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY",
    "name": "Uid_mandatory",
    "expression": "uid /= Void"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY_IDENTIFIED",
    "name": "Basic_validity",
    "expression": "name /= Void or identifiers /= Void or external_ref /= Void"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY_IDENTIFIED",
    "name": "Identifiers_valid",
    "expression": "identifiers /= Void implies not identifiers.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY_IDENTIFIED",
    "name": "Name_valid",
    "expression": "name /= Void implies not name.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY_IDENTITY",
    "name": "Purpose_valid",
    "expression": "purpose = name"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY_RELATED",
    "name": "Relationship_valid",
    "expression": "terminology (Terminology_id_openehr).has_code_for_group_id (Group_id_subject_relationship, relationship.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY_RELATIONSHIP",
    "name": "Source_valid",
    "expression": "source /= Void and then source.relationships.has (self)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY_RELATIONSHIP",
    "name": "Target_valid",
    "expression": "target /= Void and then not target.reverse_relationships.has (self)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "PARTY_RELATIONSHIP",
    "name": "Type_validity",
    "expression": "type = name"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "REFERENCE_RANGE",
    "name": "Range_is_simple",
    "expression": "(range.lower_unbounded or else range.lower.is_simple) and (range.upper_unbounded or else range.upper.is_simple)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "RESOURCE_DESCRIPTION",
    "name": "Details_valid",
    "expression": "not details.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "RESOURCE_DESCRIPTION",
    "name": "Language_valid",
    "expression": "parent_resource /= Void implies details.for_all (d | parent_resource.languages_available.has (d.language.code_string))"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "RESOURCE_DESCRIPTION",
    "name": "Lifecycle_state_valid",
    "expression": "not lifecycle_state.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "RESOURCE_DESCRIPTION",
    "name": "Original_author_valid",
    "expression": "not original_author.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "RESOURCE_DESCRIPTION",
    "name": "Parent_resource_valid",
    "expression": "parent_resource /= Void implies parent_resource.description = self"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "RESOURCE_DESCRIPTION_ITEM",
    "name": "copyright_valid",
    "expression": "copyright /= Void implies not copyright.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "RESOURCE_DESCRIPTION_ITEM",
    "name": "Language_valid",
    "expression": "code_set (Code_set_id_languages).has_code (language)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "RESOURCE_DESCRIPTION_ITEM",
    "name": "misuse_valid",
    "expression": "misuse /= Void implies not misuse.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "RESOURCE_DESCRIPTION_ITEM",
    "name": "Purpose_valid",
    "expression": "not purpose.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "RESOURCE_DESCRIPTION_ITEM",
    "name": "Use_valid",
    "expression": "use /= Void implies not use.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "REVISION_HISTORY_ITEM",
    "name": "Audit_valid",
    "expression": "not audits.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "ROLE",
    "name": "Capabilities_valid",
    "expression": "capabilities /= Void implies not capabilities.empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "SECTION",
    "name": "Items_valid",
    "expression": "items /= Void implies not items.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "TERM_MAPPING",
    "name": "Match_valid",
    "expression": "is_valid_match_code (match)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "TERM_MAPPING",
    "name": "Purpose_valid",
    "expression": "purpose /= Void implies terminology (Terminology_id_openehr).has_code_for_group_id (Group_id_term_mapping_purpose, purpose.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "TRANSLATION_DETAILS",
    "name": "Language_valid",
    "expression": "code_set (Code_set_id_languages).has_code (language)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "VERSION",
    "name": "Lifecycle_state_ valid",
    "expression": "lifecycle_state /= Void and then terminology (Term_id_openehr).has_code_for_group_id (Group_id_version_lifecycle_state, lifecycle_state.defining_code)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "VERSION",
    "name": "Owner_id_valid",
    "expression": "owner_id.value.is_equal (uid.object_id.value)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "VERSION",
    "name": "Preceding_version_uid_validity",
    "expression": "uid.version_tree_id.is_first xor preceding_version_uid /= Void"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "VERSIONED_COMPOSITION",
    "name": "Archetype_node_id_valid",
    "expression": "for_all v in all_versions | v.archetype_node_id.is_equal (all_versions.first.archetype_node_id)"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "VERSIONED_COMPOSITION",
    "name": "Persistent_validity",
    "expression": "for_all v in all_versions | v.is_persistent = all_versions.first.data.is_persistent"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "VERSIONED_OBJECT",
    "name": "All_version_ids_valid",
    "expression": "all_version_ids.count = version_count"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "VERSIONED_OBJECT",
    "name": "All_versions_valid",
    "expression": "all_versions.count = version_count"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "VERSIONED_OBJECT",
    "name": "Latest_version_valid",
    "expression": "version_count > 0 implies latest_version /= Void"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "VERSIONED_OBJECT",
    "name": "Uid_validity",
    "expression": "extension.is_empty"
  },
  {
    "schema": "rm",
    "release": "1.2.0",
    "className": "VERSIONED_OBJECT",
    "name": "Version_count_valid",
    "expression": "version_count >= 0"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "ARCHETYPE",
    "name": "Invariant_concept_valid",
    "expression": "terminology.has_term_code (concept_code)"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "ARCHETYPE",
    "name": "Invariant_specialisation_validity",
    "expression": "is_specialised implies specialisation_depth > 0"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "ARCHETYPE_CONSTRAINT",
    "name": "Post",
    "expression": "Result = soc_parent /= Void or parent.soc_parent /= Void"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "ARCHETYPE_HRID",
    "name": "Inv_class_name_validity",
    "expression": "not rm_class.is_empty"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "ARCHETYPE_HRID",
    "name": "Inv_concept_id_validity",
    "expression": "not concept_id.is_empty"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "ARCHETYPE_HRID",
    "name": "Inv_release_version_validity",
    "expression": "valid_version (release_version)"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "ARCHETYPE_HRID",
    "name": "Inv_rm_package_validity",
    "expression": "not rm_package.is_empty"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "ARCHETYPE_HRID",
    "name": "Inv_rm_publisher_validity",
    "expression": "not rm_publisher.is_empty"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "ARCHETYPE_TERMINOLOGY",
    "name": "concept_code_validity",
    "expression": "id_codes.has (concept_code)"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "ARCHETYPE_TERMINOLOGY",
    "name": "Original_language_validity",
    "expression": "code_set (Code_set_id_languages).has_concept_id (original_language)"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "ARCHETYPE_TERMINOLOGY",
    "name": "Parent_archetype_valid",
    "expression": "parent_archetype.terminology = Current"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "ARCHETYPE_TERMINOLOGY",
    "name": "Term_bindings_validity",
    "expression": "bindings /= void implies not bindings.is_empty"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "AUTHORED_ARCHETYPE",
    "name": "Description_validity",
    "expression": "description /= Void"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "AUTHORED_ARCHETYPE",
    "name": "Invariant_adl_version_validity",
    "expression": "valid_version_id (adl_version)"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "AUTHORED_ARCHETYPE",
    "name": "Invariant_rm_release",
    "expression": "valid_version_id (rm_release)"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "C_DATE",
    "name": "Pattern_validity",
    "expression": "pattern /= Void implies valid_iso8601_date_constraint_pattern(pattern)"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "C_DATE_TIME",
    "name": "Pattern_validity",
    "expression": "pattern /= Void implies valid_iso8601_date_time_constraint_pattern(pattern)"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "C_DEFINED_OBJECT",
    "name": "Inv_valid_default_value",
    "expression": "valid_value (default_value)"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "C_PRIMITIVE_OBJECT",
    "name": "Inv_valid_assumed_value",
    "expression": "valid_value (assumed_value)"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "C_TIME",
    "name": "Pattern_validity",
    "expression": "pattern /= Void implies valid_iso8601_time_constraint_pattern (pattern)"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "OPERATIONAL_TEMPLATE",
    "name": "Specialisation_validity",
    "expression": "is_specialised"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "RM_ATTRIBUTE_VISIBILITY",
    "name": "Inv_alias_validity",
    "expression": "alias /= Void implies visibility /= Void"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "TEMPLATE",
    "name": "Inv_is_specialised",
    "expression": "is_specialised"
  },
  {
    "schema": "am",
    "release": "2.4.0",
    "className": "TEMPLATE_OVERLAY",
    "name": "Inv_is_specialised",
    "expression": "is_specialised"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "BMM_ASSIGNMENT",
    "name": "Inv_target_writable",
    "expression": "target.is_writable"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "BMM_CONSTANT",
    "name": "Inv_not_nullable",
    "expression": "is_nullable = False"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "BMM_FUNCTION",
    "name": "Inv_result_type",
    "expression": "type = Result.type"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "BMM_FUNCTION",
    "name": "Inv_signature_has_result",
    "expression": "signature().result /= Void"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "BMM_FUNCTION",
    "name": "Operator_validity",
    "expression": "operator_def /= Void implies arity in |1..2|"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "BMM_MODEL",
    "name": "Inv_top_level_scope",
    "expression": "scope = self"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "BMM_PROCEDURE",
    "name": "Inv_signature_no_result",
    "expression": "signature().result = Void"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "BMM_PROPERTY",
    "name": "Inv_signature_no_args",
    "expression": "signature().arguments = Void"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "EL_AGENT_CALL",
    "name": "Inv_valid_call",
    "expression": "agent.is_callable()"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "EL_BOOLEAN_EXPRESSION",
    "name": "Inv_boolean_expression",
    "expression": "base_expression.is_boolean()"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "EL_CONDITIONAL_EXPRESSION",
    "name": "Inv_condition_boolean",
    "expression": "condition.is_boolean()"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "EL_FUNCTION_CALL",
    "name": "Inv_valid_agent",
    "expression": "agent.is_callable()"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "EL_LITERAL",
    "name": "Post_manifest_effective_type",
    "expression": "Result = definition.type"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "EL_OPERATOR",
    "name": "Symbol_validity",
    "expression": "symbol /= Void implies operator_def.symbols.has (symbol)"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "EL_TYPE_REF",
    "name": "Inv_no_context",
    "expression": "context = Void"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "EXPR_OPERATOR",
    "name": "Symbol_validity",
    "expression": "symbol /= Void implies operator_def.symbols.has (symbol)"
  },
  {
    "schema": "lang",
    "release": "1.1.0",
    "className": "P_BMM_GENERIC_PARAMETER",
    "name": "Post_name",
    "expression": "name.count = 1 and name.is_upper"
  }
];

export const BMM_CONSTANTS: Record<string, string> = {
  "Multiplicity_range_marker": "..",
  "Multiplicity_unbounded_marker": "&#42;",
  "Local_terminology_id": "local",
  "CR": "\\015",
  "LF": "\\012",
  "Any_type_name": "Any",
  "Regex_any_pattern": ".&#42;",
  "Default_encoding": "UTF-8",
  "None_type_name": "None",
  "Max_days_in_year": "Days_in_leap_year",
  "Terminology_id_openehr": "openehr",
  "Group_id_audit_change_type": "audit change type",
  "Group_id_attestation_reason": "attestation reason",
  "Group_id_composition_category": "composition category",
  "Group_id_event_math_function": "event math function",
  "Group_id_instruction_states": "instruction states",
  "Group_id_instruction_transitions": "instruction transitions",
  "Group_id_null_flavours": "null flavours",
  "Group_id_property": "property",
  "Group_id_participation_function": "participation function",
  "Group_id_participation_mode": "participation mode",
  "Group_id_setting": "setting",
  "Group_id_term_mapping_purpose": "term mapping purpose",
  "Group_id_subject_relationship": "subject relationship",
  "Group_id_version_life_cycle_state": "version lifecycle state",
  "Code_set_id_character_sets": "character sets",
  "Code_set_id_compression_algorithms": "compression algorithms",
  "Code_set_id_countries": "countries",
  "Code_set_integrity_check_algorithms": "integrity check algorithms",
  "Code_set_id_languages": "languages",
  "Code_set_id_media_types": "media types",
  "Code_set_id_normal_statuses": "normal statuses",
  "At_code_leader": "at",
  "Id_code_leader": "id",
  "Value_code_leader": "at",
  "Value_set_code_leader": "ac",
  "Specialisation_separator": ".",
  "Code_regex_pattern": "(0|[1-9][0-9]*)(\\.(0|[1-9][0-9]*))*",
  "Root_code_regex_pattern": "^(id1|at0000)(\\.1)*$",
  "Primitive_node_id": "at9999",
  "Schema_name_delimiter": "::",
  "Package_name_delimiter": ".",
  "Bmm_schema_file_extension": ".bmm",
  "Type_delimiter": ":",
  "Generic_left_delimiter": "<",
  "Generic_right_delimiter": ">",
  "Generic_separator": ",",
  "Generic_constraint_delimiter": ":",
  "Tuple_left_delim": "[",
  "Tuple_right_delim": "]",
  "Tuple_separator": ",",
  "Constraint_left_delim": "«",
  "Constraint_right_delim": "»",
  "Metadata_bmm_version": "bmm_version",
  "Metadata_schema_name": "schema_name",
  "Metadata_rm_publisher": "rm_publisher",
  "Metadata_rm_release": "rm_release",
  "Metadata_schema_revision": "schema_revision",
  "Metadata_schema_lifecycle_state": "schema_lifecycle_state",
  "Metadata_schema_description": "schema_description",
  "Metadata_schema_path": "schema_path"
};
